<template>
  <div>
    <b-button v-b-toggle="`collapse-${position}`" class="m-1"
      >{{ fieldName }} -
      <small class="font-weight-lighter">{{ fieldType }}</small></b-button
    >
    <b-collapse :id="`collapse-${position}`">
      <b-card :title="`${fieldName}'s Properties`">
        <div
          v-for="(propertyValue, propertyName) in strippedProps"
          :key="propertyName"
        >
          <span> {{ propertyName }} - {{ propertyValue }}</span>
          <br />
        </div>
      </b-card>
    </b-collapse>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    fieldName: String,
    fieldType: String,
    position: Number,
    props: Object
  },
  computed: {
    strippedProps() {
      var props = this.props;
      for (var property in props) {
        if (props[property] == null || property == "isSet")
          delete props[property];
      }
      return props;
    }
  }
};
</script>
<style scoped>
.m-1 {
  width: 100% !important;
}
</style>
